import React, { FC, useState } from 'react';
import { Link } from "react-router-dom";
import { Input, Button, Modal, Row, Col } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import _ from "lodash";
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from "reducers/rootReducer";

import useLocalStorageService from "../../services/localStorage"
import {SocketTopics} from "../../constants/enums"
import {CID,RID} from "../../constants/localStoreKeys"

import { getMessageRequestPayload, wrapRequestPayload } from '../../helpers/request/RequestPayload'

import {
    getModifyPageSubscriptionTopic
  } from "hooks/MQTTConstants";

const { TextArea } = Input;

const AddGroupModal: FC<{ onClose: () => void; socket?: ISocket }> = (props) => {
    const { onClose, socket } = props;
    const [isModalVisible, setIsModalVisible] = useState(true);
    const [key, setKey] = useState('');
    const { selectedItem } = useSelector(
        (state: RootState) => state.search
      );

    const {getLocalStorageItem} = useLocalStorageService();

    const handleCancel = () => {
        setIsModalVisible(false);
        onClose && onClose();
    };
    const dispatch = useDispatch();
    const handleOk = () => {
        sendPageUpdateEvent('createGroup', {
            name: key,
            userIds: [],
            topicTag: ''
        });
        setIsModalVisible(false);
    };

    const sendPageUpdateEvent = (type, attributes) => {

        const modifyPagePayload: IMessage = getMessageRequestPayload(getLocalStorageItem(CID),
                            getLocalStorageItem(RID),selectedItem.pageId,
                             "",type, attributes) 
        socket.publishToEvent(SocketTopics.PublishPageTopics, getModifyPageSubscriptionTopic(selectedItem.pageId), wrapRequestPayload(modifyPagePayload))
    }

    return (
        <Modal title="Create group"
            visible={isModalVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            width='480px'
            className="beam-modal"
            footer={[]}
            destroyOnClose={true}
        >
            <Row>
                <Col span={24}>
                    <Input value={key} onChange={(e)=>{setKey(e.target.value)}} placeholder="Group name" />
                </Col>
            </Row>
            <Row className="action-grp mt-4">
                <Col span={14} className="pr-2">
                    <Button className="beam-btn green-btn cover w-full" onClick={handleOk}>Add</Button>
                </Col>
                <Col span={10} className="pl-2">
                    <Button className="beam-btn orange-btn bordered w-full" onClick={handleCancel}>Cancel</Button>
                </Col>
            </Row>
        </Modal>
    )
}

export default AddGroupModal;